import { useSiteContent } from '@/context/SiteContent';
import { Wordmark } from '@/components/yunti/Wordmark';

const WAY_STYLES = {
  white: 'text-white',
  dim: 'text-white/80',
  purple: 'text-yunti-purplexl drop-shadow-sm',
};

export function TheWay() {
  const { theWay } = useSiteContent();
  return (
    <section
      id="the-way"
      className="section-pad px-6 lg:px-12 bg-yunti-green text-white relative overflow-hidden border-b border-yunti-ink/20"
      data-testid="the-way-section"
    >
      <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10">
        <span className="inline-block text-xs font-mono uppercase tracking-[0.28em] text-yunti-purplelight bg-white/10 px-4 py-1.5 border border-white/15">
          {theWay.badge}
        </span>

        <div className="space-y-4 text-3xl md:text-5xl lg:text-6xl font-display uppercase tracking-tight leading-tight">
          {theWay.lines.map((line, i) => (
            <p key={i} className={WAY_STYLES[line.style] || WAY_STYLES.white}>
              <Wordmark text={line.text} />
            </p>
          ))}
        </div>

        <div className="pt-6">
          <div className="inline-flex flex-wrap justify-center items-center gap-2 text-xs font-mono text-white/60 tracking-widest uppercase">
            {theWay.tokens.map((token, i) => (
              <span key={i} className="inline-flex items-center gap-2">
                {i > 0 && (
                  <span className="text-yunti-purplelight" aria-hidden="true">
                    ⇄
                  </span>
                )}
                <span>[ {token} ]</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
